exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.claim-value[data-v-1edb0c08] {\n  font-size: 20px;\n  font-weight: 500;\n}\n.claim-status[data-v-1edb0c08] {\n  font-size: 12px;\n  font-weight: 400;\n  color: #bec0ca;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1edb0c08","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard/salesDashboard/subcomponents/cards/Claims.vue
// module id = 8Yu1
// module chunks = 0